import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { CreateInformationCommand } from 'src/app/core/api/models';
import { InformationsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { PeriodicDateConfig } from 'src/app/shared/components/periodic-date-picker/periodic-date-picker.component';
import { AppNgxEditorComponent } from '../../../../shared/components/text-editor/app-ngx-editor/app-ngx-editor.component';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';

@Component({
  selector: 'app-informations-form',
  imports: [BaseFormModule, AppNgxEditorComponent],
  templateUrl: './informations-form.component.html',
})
export class InformationsFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<any> = {};
  model: CreateInformationCommand = {};
  periodicDateConfig: PeriodicDateConfig;
  protected currentService = inject(InformationsService);

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.initForm();
      this.setComponentsConfig();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  setComponentsConfig() {
    try {
      this.periodicDateConfig = {
        startDateLabel: this.fields + 'startDate',
        endDateLabel: this.fields + 'endDate',
        startDateFormControl: this.form?.get('startDate') as FormControl,
        endDateFormControl: this.form?.get('endDate') as FormControl,
        responsiveClassName: 'sm:tw-w-1/2',
        isEditMode: this.formPageConfig?.isEditMode,
        minStartDateType: 'custom',
        isShowEndDate: true,
        isShowStartDate: true,
        startDateValue: this.model.startDate,
      };
      if (this.formPageConfig.isEditMode) {
        this.periodicDateConfig.startDateValue =
          this.formPageConfig.editData.startDate;
        this.periodicDateConfig.endDateValue =
          this.formPageConfig.editData.endDate;
      } else {
        this.periodicDateConfig.startDateValue = this.model.startDate;
      }
    } catch (error) {
      this.loggerService.logError(
        'app-base-statistical-form',
        error,
        EventTypes.statisticalReports
      );
    }
  }

  //#region init methods
  initModel() {
    super.initModel();
    if (!this.formPageConfig.isEditMode)
      this.model.startDate = DateTimeService.getTodayDate();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      contentText: new FormControl(this.model.contentText, Validators.required),
      customerDomainId: new FormControl('', Validators.required),
      displayForAllSubOrganizations: new FormControl(''),
      endDate: new FormControl('', Validators.required),
      isActive: new FormControl(''),
      isRequiredToSeen: new FormControl(''),
      startDate: new FormControl('', Validators.required),
    });
  }

  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateInformationCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .informationsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: any): void {
    this.unSubs();

    this.loading = true;

    this.currentService
      .informationsUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      //convert date
      this.model.startDate = DateTimeService.toUTC(this.model.startDate);
      this.model.endDate = DateTimeService.toUTC(this.model.endDate);
      this.model.contentText = this.form.get('contentText')?.value;

      if (this.formPageConfig.isEditMode) this.baseUpdateApi(this.model);
      else this.baseCreateApi(this.model);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
}
